import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg, useFetch } from "@/lib/api";
import { fmtDate, gbp } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { PageHeader, Loading, ErrorBox, EmptyState, Section, StatusBadge } from "@/components/Common";
import { QuoteView } from "@/components/QuoteView";

export function Quotations() {
  const { data, loading, error } = useFetch("/customer/quotations");
  if (loading) return <Loading />;
  return (
    <div>
      <PageHeader title="Quotations" />
      <ErrorBox error={error} />
      {!data?.length ? <EmptyState title="No quotations yet" text="When DJ Landscapes issues a quotation for one of your requests it will appear here." /> : (
        <div className="space-y-2">{data.map((q) => (
          <Link key={q.id} to={`/portal/quotations/${q.id}`} data-testid={`quote-row-${q.reference}`} className="flex items-center justify-between rounded-md border border-border bg-card p-4 hover:bg-muted">
            <span><span className="font-medium">{q.reference}</span> · {gbp(q.total)}<br /><span className="text-xs text-muted-foreground">Request {q.request_reference} · valid until {fmtDate(q.expiry_date)}</span></span>
            <StatusBadge status={q.status} />
          </Link>))}</div>
      )}
    </div>
  );
}

export function QuotationDetail() {
  const { id } = useParams();
  const { data: q, loading, error, reload } = useFetch(`/customer/quotations/${id}`);
  const [busy, setBusy] = useState(false);
  if (loading) return <Loading />;
  if (error) return <ErrorBox error={error} />;
  const decide = async (d) => {
    if (!window.confirm(d === "accept" ? `Accept quotation ${q.reference} for ${gbp(q.total)}?` : `Decline quotation ${q.reference}?`)) return;
    setBusy(true);
    try { await api.post(`/customer/quotations/${id}/${d}`, {}); toast.success(d === "accept" ? "Quotation accepted. DJ Landscapes will be in touch to schedule the work." : "Quotation declined"); reload(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="mx-auto max-w-3xl">
      <PageHeader title="Your quotation" />
      <Section>
        <QuoteView q={q} />
        {q.status === "Sent" && (
          <div className="mt-6 flex flex-wrap gap-2 border-t border-border pt-4">
            <Button onClick={() => decide("accept")} disabled={busy} data-testid="quote-accept-btn">Accept quotation</Button>
            <Button variant="outline" onClick={() => decide("decline")} disabled={busy} data-testid="quote-decline-btn">Decline</Button>
            <p className="w-full text-xs text-muted-foreground">No payment is taken through this portal.</p>
          </div>
        )}
      </Section>
    </div>
  );
}
